var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgView = function SvgView(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "view-svg",
    width: 19.921,
    height: 19.921,
    viewBox: "0 0 19.921 19.921",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-43.167 -166.472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.029,484.164a.827.827,0,0,1-.587-.243l-6.131-6.131a.83.83,0,1,1,1.174-1.174l6.131,6.131a.83.83,0,0,1-.587,1.417Z",
    transform: "translate(-297.771 -297.771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.052,166.472a7.885,7.885,0,1,0,7.885,7.885A7.892,7.892,0,0,0,51.052,166.472Zm0,12.035a6.191,6.191,0,0,1-5.769-3.926.6.6,0,0,1,0-.448,6.2,6.2,0,0,1,11.537,0,.6.6,0,0,1,0,.448A6.191,6.191,0,0,1,51.052,178.507Zm0-6.225a2.075,2.075,0,1,0,2.075,2.075A2.076,2.076,0,0,0,51.052,172.282Z",
    transform: "translate(0 0)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgView, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/view.4263acd9.svg";
export { ForwardRef as ReactComponent };